export interface Step1FormData {
  arNumber: string;
  companyName: string;
  username: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
}

/** Fixed expedite fee amount in USD */
export const EXPEDITE_FEE = 200.0;

/** Review note text displayed on Summary step */
export const REVIEW_NOTE =
  "Please take a moment to review your request. By clicking 'Save' you are confirming and saving this request. Use the 'Back' button to make any adjustments.";

/** Confirmation message displayed on Step 5 after successful submission */
export const CONFIRMATION_MESSAGE =
  'The Request has been received by UKG Inc Print Services. Please note the Request Number: {REQUEST_NUMBER} for future reference. An email confirmation should be received shortly. For your convenience, the status of the request can be viewed at any time on the Requests page.';

export interface WizardStep {
  stepNumber: number;
  label: string;
}

export const WIZARD_STEPS: WizardStep[] = [
  { stepNumber: 1, label: 'Contact Info' },
  { stepNumber: 2, label: 'File(s) Upload' },
  { stepNumber: 3, label: 'Expedite Request' },
  { stepNumber: 4, label: 'Summary' },
  { stepNumber: 5, label: 'Confirmation' },
];

export const TOTAL_STEPS = 5;

export interface ExpediteFormData {
  /**
   * Whether the user wants expedited processing.
   * Default: true (Yes is pre-selected)
   */
  isExpedited: boolean;

  /**
   * Timestamp when the selection was last modified.
   * Optional - for tracking purposes.
   */
  selectedAt?: Date;
}
